import { Switch, Route, Router as WouterRouter, useLocation } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/layout";
import { useEffect, useRef } from "react";

import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Menu from "@/pages/menu";
import Interior from "@/pages/interior";
import Afisha from "@/pages/afisha";
import NovyyGod2027 from "@/pages/novyy-god-2027";
import Banket from "@/pages/banket";
import Contacts from "@/pages/contacts";
import Privacy from "@/pages/privacy";
import Admin from "@/pages/admin";
import Sertifikat from "@/pages/sertifikat";
import Vakansii from "@/pages/vakansii";
import DenRozhdeniya from "@/pages/den-rozhdeniya";
import Svadba from "@/pages/svadba";
import Korporativ from "@/pages/korporativ";
import RomanticheskiyUzhin from "@/pages/romanticheskiy-uzhin";
import Terrasa from "@/pages/terrasa";
import ZhivayaMuzyka from "@/pages/zhivaya-muzyka";
import Faq from "@/pages/faq";
import Blog from "@/pages/blog";
import BlogPost from "@/pages/blog-post";
import Otzyvy from "@/pages/otzyvy";
import Pressa from "@/pages/pressa";
import MenuConstructor from "@/pages/menu-constructor";

function Ga4Tracker() {
  const [location] = useLocation();
  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) { isFirst.current = false; return; }
    if (typeof window !== "undefined" && typeof (window as any).gtag === "function") {
      (window as any).gtag("event", "page_view", {
        page_path: location,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function Router() {
  return (
    <Switch>
      <Route path="/admin" component={Admin} />
      <Route>
        <Layout>
          <Switch>
            <Route path="/" component={Home} />
            <Route path="/menu" component={Menu} />
            <Route path="/interior" component={Interior} />
            <Route path="/afisha" component={Afisha} />
            <Route path="/novyy-god-2027" component={NovyyGod2027} />
            <Route path="/banket" component={Banket} />
            <Route path="/contacts" component={Contacts} />
            <Route path="/sertifikat" component={Sertifikat} />
            <Route path="/vakansii" component={Vakansii} />
            <Route path="/den-rozhdeniya" component={DenRozhdeniya} />
            <Route path="/svadba" component={Svadba} />
            <Route path="/korporativ" component={Korporativ} />
            <Route path="/romanticheskiy-uzhin" component={RomanticheskiyUzhin} />
            <Route path="/terrasa" component={Terrasa} />
            <Route path="/zhivaya-muzyka" component={ZhivayaMuzyka} />
            <Route path="/faq" component={Faq} />
            <Route path="/otzyvy" component={Otzyvy} />
            <Route path="/pressa" component={Pressa} />
            <Route path="/blog/:slug" component={BlogPost} />
            <Route path="/blog" component={Blog} />
            <Route path="/menu-constructor" component={MenuConstructor} />
            <Route path="/privacy" component={Privacy} />
            <Route component={NotFound} />
          </Switch>
        </Layout>
      </Route>
    </Switch>
  );
}

export function AppContent() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Ga4Tracker />
        <Router />
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default function App() {
  return (
    <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
      <AppContent />
    </WouterRouter>
  );
}
